import React, { useContext } from 'react'

import { useMutation } from '@apollo/client'
import { formatDistanceToNowStrict } from 'date-fns'

import { ConfirmWithState as Confirm } from 'tools/Modal/Confirm'
import notify, { readableError } from 'tools/Notify'

import { LOAD_ORG, ORG_INVITE } from '../graphql'
import OrgContext from '../reducer'

function Invites({ canChange }) {
  const [org] = useContext(OrgContext)

  return (
    <table className="list w-100">
      <thead>
        <tr>
          <th className="pl2">Requestor</th>
          <th>Invited Email</th>
          <th>Role</th>
          <th>Expires in</th>
          <th>Resend</th>
          <th>Cancel</th>
        </tr>
      </thead>
      <tbody>
        {org.pendingInvites.map((invite) => (
          <InviteRow key={invite.id} invite={invite} canChange={canChange} />
        ))}
      </tbody>
    </table>
  )
}

function InviteRow({ invite, canChange }) {
  const {
    id,
    email,
    expiresAt,
    orgId,
    requestor: { name: requestorName },
    role
  } = invite

  const [, notifyD] = useContext(notify.Context)
  const [cancelInvite] = useMutation(ORG_INVITE, {
    variables: {
      id,
      action: 'CANCEL'
    },
    refetchQueries: [{ query: LOAD_ORG, variables: { id: orgId } }],
    onCompleted({ orgChange: data }) {
      if (data?.success !== true) {
        notify.error(notifyD, readableError(data?.reason))
      }
    }
  })

  const [resendInvite] = useMutation(ORG_INVITE, {
    variables: {
      id,
      action: 'REQUEST'
    },
    refetchQueries: [{ query: LOAD_ORG, variables: { id: orgId } }],
    onCompleted({ orgChange: data }) {
      if (data?.success === true) {
        const result = data.result
        notify.info(notifyD, `${result.email} re-invited`)
      } else {
        notify.error(notifyD, readableError(data?.reason))
      }
    }
  })

  const expires = new Date(expiresAt)
  const expiration = formatDistanceToNowStrict(expires)

  return (
    <tr>
      <td className="pl2">{requestorName}</td>
      <td>{email}</td>
      <td>{role}</td>
      <td>{expiration}</td>
      <td>
        <Confirm
          className="di"
          title="Resend invite?"
          label={
            <button className="clear">
              <i className="fa fa-paper-plane" />
            </button>
          }
          onConfirm={resendInvite}
        />
      </td>
      <td>
        <Confirm
          className="di"
          title="Cancel invite?"
          label={
            <button className="clear">
              <i className="fa fa-trash" />
            </button>
          }
          onConfirm={cancelInvite}
        />
      </td>
    </tr>
  )
}

export default Invites
